import { useTranslation } from 'react-i18next'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { FlowValues } from '@flows/core/types/stepTypes'

export const useStepContentText = (flowValues: FlowValues) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  return processStepContentElementText(t, { flowValues, servicesResponses })
}
